namespace TabAurous.Production {
    export namespace JWReceiptInspectionValuesService {
        export const baseUrl = 'Production/JWReceiptInspectionValues';

        export declare function Create(request: Serenity.SaveRequest<JWReceiptInspectionValuesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<JWReceiptInspectionValuesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<JWReceiptInspectionValuesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<JWReceiptInspectionValuesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/JWReceiptInspectionValues/Create",
            Update = "Production/JWReceiptInspectionValues/Update",
            Delete = "Production/JWReceiptInspectionValues/Delete",
            Retrieve = "Production/JWReceiptInspectionValues/Retrieve",
            List = "Production/JWReceiptInspectionValues/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>JWReceiptInspectionValuesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
